<script>
// import(`./${type}.vue`) can't be resolved by Vite's dynamic-import-vars plugin
// because it imports its own directory without a filename prefix, so it stays
// unbundled and 404s in production. import.meta.glob is analyzed statically and
// generates a real lazy-loaded chunk per pipe component instead.
const pipes = import.meta.glob(['./*.vue', '!./ActivityLogTablePipe.vue']);

export default {
  name: 'ActivityLogTableDataPipe',
  props: {
    type: {
      type: [String],
    },
    value: {
      type: [String, Number, Array, Boolean, Object],
    },
  },
  computed: {
    pipeComponent() {
      if (!this.type) return null;
      return pipes[`./${this.type}.vue`] || null;
    },
  },
};
</script>

<template lang="pug">
div
  span(v-if="!type") {{ value }}
  component(v-if="type" :is="pipeComponent" :value="value")
</template>
